import formatAmount from '@modules/calculator/utils/formatAmount';
export const getFundingProgress = (investment) => `${formatAmount(investment.fundingProgressAmount)} (${Number(investment.fundingProgressPercent).toFixed(2)}%)`;
